module.exports = __webpack_public_path__ + "static/img/lgny.a0ce060.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/lgny.png
// module id = Djb5
// module chunks = 0